import * as React from 'react';
import { VelocityTransitionGroup } from 'velocity-react';
import { MenuItem } from 'sos-common/js/components/MobileMenu/MobileMenu.types';
import { ITreeNodeProps, ITreeNodeState } from './SubNavigation.types';

function getMenuItems(node: MenuItem, lang: string) {
  return fetch('/_api/menu/getchildren?contentId=' + node.Id + '&lang=' + lang, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((response) => {
    return response.json();
  });
}

export class TreeNode extends React.Component<ITreeNodeProps, ITreeNodeState> {
  private NodeId: string;
  private IndentClass: string;

  constructor(props: ITreeNodeProps) {
    super(props);
    this.NodeId = `node_${props.Node.Id}`;
    this.IndentClass = ` sub-navigation__item--level${this.props.Level}`;
    this.state = {
      Node: this.props.Node,
      Selected: this.props.Node.Selected,
      Expanded: this.props.Node.Expanded,
      IsCurrentPage: this.props.Node.Id === this.props.CurrentPageId,
    };
  }

  toggleExpanded(id, event): void {
    let that = this;
    event.preventDefault();
    this.setState((prevState) => ({
      Expanded: !prevState.Expanded,
    }));

    if (
      this.props.Node.Children.filter(
        (x) => (x.HasChildren || x.HasContainerPageChildren) && (x.Children === undefined || x.Children.length === 0),
      ) !== undefined &&
      !this.state.Expanded
    ) {
      getMenuItems(this.props.Node, this.props.Language).then((data) => {
        let items: Array<MenuItem> = JSON.parse(JSON.stringify(data));
        items.forEach(function (menuItem) {
          that.props.Node.Children.push(menuItem);
        });
        this.setState({
          Node: this.props.Node,
        });
      });
    }
  }

  render(): JSX.Element {
    let otherAttr: React.HTMLAttributes<any> = {};

    let itemClass = 'sub-navigation__item';
    let toggleClass = '';
    if (this.state.Expanded) {
      itemClass += ' sub-navigation__item--expanded';
    }
    if (this.state.IsCurrentPage) {
      itemClass += ' sub-navigation__item--current';
      toggleClass = 'sub-navigation__toggle-area--current';
      otherAttr['aria-current'] = 'page';
    }

    const linkElement: JSX.Element = this.props.Node.IsContainerPage ? (
      <span className="sub-navigation__containerpage-name">{this.props.Node.Name}</span>
    ) : (
      <a href={this.props.Node.Url} className={'sub-navigation__link'} {...otherAttr}>
        {this.props.Node.Name}
      </a>
    );

    const node = this.props.Node;
    const toggle = this.state.Expanded ? '' : 'plus-minus-toggle--collapsed';
    const ariaLabel = this.state.Expanded ? 'Stäng undersidor' : 'Öppna undersidor';
    let expandCollapseIcon = (
      <div className={`sub-navigation__toggle-area ${toggleClass} sub-navigation__toggle-area--childless`}>
        <span />
      </div>
    );
    if (node.HasChildren || node.HasContainerPageChildren) {
      expandCollapseIcon = (
        <div className={`sub-navigation__toggle-area ${toggleClass}`}>
          <button
            aria-label={ariaLabel}
            aria-controls={this.NodeId}
            className={`stripped-button plus-minus-toggle ${toggle}`}
            aria-expanded={this.state.Expanded}
            onClick={this.toggleExpanded.bind(this, node.Id)}
          />
        </div>
      );
    }

    const children = [];
    if (node.Children) {
      let that = this;
      node.Children.forEach(function (node) {
        children.push(
          <TreeNode
            Node={node}
            key={node.Id}
            Level={that.props.Level + 1}
            Language={that.props.Language}
            Visible={that.state.Expanded && that.props.Visible}
            CurrentPageId={that.props.CurrentPageId}
          />,
        );
      });
    }

    const indent = this.state.Expanded ? ' sub-navigation__indent' : '';
    const wrapper = this.state.Expanded ? ' sub-navigation__item-wrapper--expanded' : '';
    const current = this.state.IsCurrentPage ? ' sub-navigation__item-wrapper--current' : '';

    return (
      <li className={itemClass + this.IndentClass} key={node.Id}>
        <div
          onClick={this.props.Node.IsContainerPage ? this.toggleExpanded.bind(this, node.Id) : null}
          className={`sub-navigation__item-wrapper sub-navigation__item-wrapper--level${
            this.props.Level + wrapper + current
          }`}
          style={
            !this.props.Node.HasChildren && !this.props.Node.HasContainerPageChildren
              ? { width: '100%', paddingRight: '3.9rem' }
              : {}
          }>
          {linkElement}
        </div>
        {expandCollapseIcon}

        <div className="sub-navigation__menu-wrapper">
          {this.state.Expanded && (node.HasChildren || node.HasContainerPageChildren) && (
            <ul className={`sub-navigation__menu ${indent}`} id={this.NodeId}>
              <VelocityTransitionGroup
                component={null}
                enter={{
                  animation: 'slideDown',
                  display: 'flex',
                  duration: 200,
                }}
                leave={{ animation: 'slideUp', duration: 200 }}>
                {this.state.Expanded ? children : null}
              </VelocityTransitionGroup>
            </ul>
          )}
        </div>
      </li>
    );
  }
}
